import React, { lazy, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import CloseIcon from '@mui/icons-material/Close';
import CssBaseline from '@mui/material/CssBaseline';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';

import { getDesignTokens } from './utils/theme';
import Router from './router';

import 'react-toastify/dist/ReactToastify.min.css';
import './App.css';
import './notify.css';
import './CustomTooltip.css';

const Maintenance = lazy(() => import('./pages/Maintenance'));
const AppScripts = lazy(() => import('./components/AppScripts/AppScripts'));

const App = () => {
  const shouldLog = useRef(true);

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      if (
        window.location.origin === 'https://staging.dante-ai.com' ||
        window.location.origin === 'https://d24dh0i3qzotw3.cloudfront.net'
      ) {
        const hardcodedPassword = 'Dante@111';
        const passwordInput = prompt('Enter the password to access this app:');

        if (!passwordInput) {
          alert('Incorrect password. You are not authorized to use this app.');
          window.location.href = 'https://www.google.com/';
        } else if (passwordInput) {
          if (passwordInput !== hardcodedPassword) {
            alert('Incorrect password. You are not authorized to use this app.');
            window.location.href = 'https://www.google.com/';
          }
        } else {
          window.location.href = 'https://www.google.com/';
        }
      }
    }
    //Cleans up google analytics parameters from the url bar
    const url = window.location.href;
    const urlParts = url.split('?');
    const params = new URLSearchParams(urlParts[1]);
    params.delete('_gl');
    params.delete('deviceId');
    let newUrl = urlParts[0] + '?' + params.toString();
    const length = newUrl.length;
    if (newUrl.charAt(length - 1) === '?') {
      newUrl = newUrl.slice(0, length - 1);
    }
    window.history.replaceState({}, document.title, newUrl);
  }, []);
  const maintenance = import.meta.env.VITE_APP_MAINTENANCE_MODE === 'true';
  const CloseButton = ({ closeToast }) => (
    <i className="material-icons" style={{ color: 'white' }} onClick={closeToast}>
      <CloseIcon fontSize="small" sx={{ color: 'white', cursor: 'pointer' }} />
    </i>
  );
  const darkMode = useSelector((state) => state.darkMode.darkMode);

  const mode = darkMode.isDarkMode ? 'dark' : 'light';

  const themeDante = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ThemeProvider theme={themeDante}>
      <CssBaseline />
      {maintenance ? <Maintenance /> : <Router />}
      <ToastContainer closeButton={CloseButton} />
      {!window.location.pathname.includes('embed') && <AppScripts />}
    </ThemeProvider>
  );
};

export default App;
